module.exports = __webpack_public_path__ + "@/assets/img/barcode-read.fbb7fb1a.svg";